<template>
  <div>

    <Card>

      <Select v-model="searchKey" style="width:200px;padding: 10px;" clearable>
          <Option v-for="item in storageMediaColumns" :value="item.key" :key="item.key">{{ item.title }}</Option>
      </Select>

      <Input v-model="searchValue" placeholder="Enter something..." style="width: 200px;padding: 10px;" clearable @keyup.enter.native="storageMedia"></Input>

      <Button type="primary" :loading="loading" icon="checkmark-round" style="margin-right: 10px;" @click="storageMedia">
          <span v-if="!loading">搜索</span>
          <span v-else>Loading...</span>
      </Button>

      <Button type="info" @click="addStorageMedia">新增</Button>

      <tables border v-model="storageMediaData" :loading="loading" :columns="storageMediaColumns"  @on-delete="handleDelete"/>

      <page :total="total" :current="pageIndex" :page-size="pageSize" @on-change="currentChange" show-elevator show-sizer @on-page-size-change="pageSizeChange"></page>

    </Card>

    <drag-drawer v-model="storageMediaModal"
      :width.sync="drag_drawer_width"
      :min-width="300"
      placement="right"
      :draggable="true"
      :scrollable="true">

      <div slot="header">
        <Icon type="md-aperture" :size="18"></Icon>
        <b> {{ storageMediaInfo.id === undefined || storageMediaInfo.id === null ? '新增' : '编辑' }} </b>
      </div>

      <Form ref="storageMediaForm" :model="storageMediaInfo" inline :label-width="100" label-position="right" :rules="storageMediaRule">
        <div>
          <FormItem label="平台" style="width: 100%" prop="platform">
            <Select v-model="storageMediaInfo.platform" :disabled="!(storageMediaInfo.id === undefined || storageMediaInfo.id === null)" style="min-width:220px">
              <Option :value="item.type" :key="item.type" v-for="item in storageMediaTypeList">{{ item.type }}</Option>
            </Select>
          </FormItem>
          <Divider orientation="left">基础信息</Divider>
          <FormItem :label="value" :prop="key" v-for="(value, key) in {name: '名称', account: '账号', password: '密码', AK: 'AK', SK: 'SK', ipOrDomain:'IP（域名）'}" :key="key">
            <Input v-model="storageMediaInfo[key]" style="min-width: 220px" />
          </FormItem>
        </div>

        <FormItem label="备注" style="width: 100%">
          <Input type="textarea" v-model="storageMediaInfo.remark" />
        </FormItem>

        <FormItem>
          <Row>
            <Col span="6" offset="8">
              <i-button type="primary" @click="submit()">提交</i-button>
            </Col>
            <Col span="6" offset="4">
              <i-button style="margin-left: 8px" @click="storageMediaModal = false">取消</i-button>
            </Col>
          </Row>
        </FormItem>

      </Form>
    </drag-drawer>

    <!-- 日志-->
    <BaseLogModal
      :visible="logShow"
      :api.sync="logApi"
      :slot-content="false"
      :query="{
        dataId:logId,
        dataType:2
      }"
      @closeModal="e=>{logShow=e}"
    />

  </div>
</template>

<script>
import Tables from '_c/tables'
import { storageMedia, InsertStorageMedia, DeleteStorageMedia, UpdateStorageMedia, storageMediaType } from '@/api/backup-storage'
import DragDrawer from '_c/drag-drawer'
import BaseLogModal from './log'
import config from '@/config'
export default {
  name: 'StorageMedia',
  props: {
  },
  components: {
    Tables,
    DragDrawer,
    BaseLogModal
  },
  data () {
    return {
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      searchKey: '',
      searchValue: '',
      loading: false,
      storageMediaModal: false,
      drag_drawer_width: 710,
      // 日志
      logShow: false,
      logId: null,
      logApi: `${config.backupStorageApi}/sys-user-opera-log`,
      storageMediaColumns: [
        { title: '名称', key: 'name', ellipsis: true, tooltip: true, align: 'center' },
        { title: '账号', key: 'account', ellipsis: true, tooltip: true, align: 'center' },
        { title: '密码', key: 'password', ellipsis: true, tooltip: true, align: 'center' },
        { title: '平台', key: 'platform', ellipsis: true, tooltip: true, align: 'center' },
        { title: 'AK', key: 'AK', ellipsis: true, tooltip: true, align: 'center' },
        { title: 'SK', key: 'SK', ellipsis: true, tooltip: true, align: 'center' },
        { title: 'IP（域名）', key: 'ipOrDomain', ellipsis: true, tooltip: true, align: 'center' },
        {
          title: '操作',
          key: 'opeation',
          minWidth: 140,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Poptip',
                {
                  style: {
                    marginLeft: '5px',
                    marginRight: '5px'
                  },
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'top',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.handleDelete(params)
                    }
                  }
                },
                [
                  h(
                    'Button',
                    {
                      props: {
                        type: 'error',
                        size: 'small'
                      }
                    },
                    '删除'
                  )
                ]
              ),
              h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginRight: '5px',
                  marginBottom: '5px',
                  marginTop: '5px'
                },
                on: {
                  click: () => {
                    this.storageMediaInfo = params.row
                    this.storageMediaModal = true
                  }
                }
              }, '编辑'),
              h('Button', {
                props: {
                  type: 'dashed',
                  size: 'small'
                },
                style: {
                  marginRight: '5px',
                  marginBottom: '5px',
                  marginTop: '5px'
                },
                on: {
                  click: () => {
                    this.showLogEvent(params.row)
                  }
                }
              }, '日志')
            ])
          }
        }
      ],
      storageMediaData: [],
      storageMediaTypeList: [],
      storageMediaInfo: {
        name: null,
        hostIp: null,
        attribute: null,
        platform: null,
        area: null,
        username: null,
        password: null,
        remark: null
      },
      storageMediaRule: {
        name: [{ required: true, message: '名称填写不能为空', trigger: 'blur' }]
      }
    }
  },
  watch: {
  },
  methods: {

    handleDelete (params) {
      const { id } = params.row
      DeleteStorageMedia({ id: id }).then(rsp => {
        const { data } = rsp
        this.$Message.success(data.message)
        this.storageMedia()
      }).catch(err => {
        const { message } = JSON.parse(err.request.responseText)
        this.$Message.error(message)
        this.storageMedia()
      })
    },

    storageMedia (current) {
      const params = {
        pageSize: this.pageSize,
        pageIndex: current,
        currentPage: current
      }
      if (this.searchKey) {
        params[this.searchKey] = this.searchValue
      }

      storageMedia(params).then(rsp => {
        const { data } = rsp
        if (data) {
          this.storageMediaData = data.items
          this.total = data.total
        }
      })
    },

    submit () {
      this.$refs['storageMediaForm'].validate((valid) => {
        if (valid) {
          if (this.storageMediaInfo.id === undefined || this.storageMediaInfo.id === null) {
            InsertStorageMedia(this.storageMediaInfo).then(rsp => {
              const { data } = rsp
              this.$Message.success(data.message)
              this.storageMediaModal = false
              this.storageMedia()
            }).catch(err => {
              const { message } = JSON.parse(err.request.responseText)
              this.$Message.error(message)
              this.storageMediaModal = false
              this.storageMedia()
            })
          } else {
            UpdateStorageMedia(this.storageMediaInfo).then(rsp => {
              const { data } = rsp
              this.$Message.success(data.message)
              this.storageMediaModal = false
              this.storageMedia()
            }).catch(err => {
              const { message } = JSON.parse(err.request.responseText)
              this.$Message.error(message)
              this.storageMediaModal = false
              this.storageMedia()
            })
          }
        } else {
          this.$Message.error('请检查是否存在填写异常项')
        }
      })
    },

    addStorageMedia: function () {
      this.storageMediaModal = true
      this.storageMediaInfo = {
        id: null,
        name: null,
        hostIp: null,
        attribute: null,
        platform: null,
        area: null,
        username: null,
        password: null,
        remark: null
      }
    },

    showLogEvent (row) {
      this.logShow = false
      this.logId = row.id
      this.logShow = true
    },

    storageMediaType () {
      storageMediaType().then(rsp => {
        const { data } = rsp
        if (data) {
          this.storageMediaTypeList = data.items
        }
      })
    },

    currentChange (e) {
      this.pageIndex = e
      this.storageMedia(e)
    },

    pageSizeChange (e) {
      this.pageSize = e
      this.storageMedia()
    }

  },

  created: function () {
  },

  mounted: function () {
    this.storageMedia()
    this.storageMediaType()
  }

}
</script>
